import { Phone } from '@phosphor-icons/react';

export default function StickyCallBar() {
  return (
    <a href="tel:3059048567" data-testid="sticky-call-bar"
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-[#E31937] text-white flex items-center justify-center gap-2 py-3.5 font-bold text-sm uppercase tracking-wider">
      <Phone size={18} weight="bold" /> Call 305-904-8567
    </a>
  );
}
